module.exports = __webpack_public_path__ + "img/delivery-addresses.64e1d02c.svg";